import React from 'react'
import { useTranslation } from 'react-i18next'

import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'
import MuiSelect, { SelectChangeEvent } from '@mui/material/Select'

interface SelectProps<T> {
  inventoryId: string
  label: string
  id: string
  isDisabled?: boolean
  value: T
  errorMessage?: string
  options: Array<{ value: T; label: string }>
  setFn: (newValue: T) => void
}

const Select = <T extends number>(props: SelectProps<T>): JSX.Element => {
  const { t } = useTranslation()

  return (
    <FormControl fullWidth error={!!props.errorMessage} disabled={props.isDisabled}>
      <InputLabel htmlFor={props.id}>{props.label}</InputLabel>
      <MuiSelect
        native
        id={props.id}
        value={(props.value || '').toString()}
        label={props.label}
        disabled={props.isDisabled}
        onChange={(event: SelectChangeEvent) => {
          const newValue = parseInt(event.target.value) as T
          props.setFn(newValue)
        }}
      >
        <option disabled value="">
          {t('inventory.selectvalue')}
        </option>
        {props.options.map((x) => (
          <option key={x.value} value={x.value}>
            {x.label}
          </option>
        ))}
      </MuiSelect>
      {!!props.errorMessage && <FormHelperText>{props.errorMessage}</FormHelperText>}
    </FormControl>
  )
}

export default Select
